import styled from 'styled-components';
import { ListItem } from '@material-ui/core';
import MList, { ListProps } from '@material-ui/core/List';
import MLIText, { ListItemTextProps } from '@material-ui/core/ListItemText';
import { lighten, rgba } from 'polished';

const THEME_COLOR = '#6b63d5';

export const Container = styled.div<{ colors: string[] }>`
  height: 100vh;
  width: 280px;
  background: ${THEME_COLOR};
  box-shadow: 4px 0 10px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${lighten(0.1, THEME_COLOR)};
  }

  &::-webkit-scrollbar-thumb {
    background: ${lighten(0.2, THEME_COLOR)};
    border-radius: 3px;
  }
`;

export const List = styled(MList)<ListProps & { colors: string[] }>`
  padding: 16px 0;
`;

export const ListItemText = styled(MLIText)<ListItemTextProps & { color: string }>`
  .MuiTypography-root {
    color: ${props => props.color || '#fff'};
    font-size: 0.95rem;
    font-weight: 500;
    letter-spacing: 0.2px;
  }
`;

export const ItemList = styled(ListItem)<{ isTitle?: boolean; isDisabled?: boolean }>`
  padding: 12px 24px;
  opacity: 1 !important;
  position: relative;
  transition: all 0.2s ease;

  ${props => props.isTitle && `
    margin-top: 24px;
    margin-bottom: 8px;
    opacity: 0.7 !important;
    pointer-events: none;
    
    .MuiTypography-root {
      font-weight: 600;
      text-transform: uppercase;
      font-size: 0.75rem;
      letter-spacing: 1px;
    }
  `}

  ${props => !props.isDisabled && `
    &:hover {
      background: ${rgba('#fff', 0.1)};
      
      &::before {
        opacity: 1;
        transform: scaleY(1);
      }
    }

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 4px;
      background: #fff;
      opacity: 0;
      transform: scaleY(0.6);
      transition: all 0.2s ease;
    }
  `}

  ${props => props.isDisabled && `
    opacity: 0.5 !important;
    pointer-events: none;
  `}
`;

export const Icon = styled.i`
  color: #fff;
  font-size: 20px;
  margin-right: 12px;
  opacity: 0.9;
`;

export const CategoryDivider = styled.div`
  height: 1px;
  background: ${rgba('#fff', 0.1)};
  margin: 8px 24px;
`;

export const DrawerHeader = styled.div`
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${lighten(0.05, THEME_COLOR)};
  border-bottom: 1px solid ${rgba('#fff', 0.1)};

  img {
    height: 32px;
    width: auto;
  }
`;

export const DrawerFooter = styled.div`
  padding: 16px 24px;
  background: ${lighten(0.02, THEME_COLOR)};
  border-top: 1px solid ${rgba('#fff', 0.1)};
  font-size: 0.8rem;
  color: ${rgba('#fff', 0.7)};
  text-align: center;
`;